<template>
    <div class="expertise-explore">
        <div class="expertise-explore-header">
            <router-link class="expertise-explore-header__close-btn-link" to="/expertise">
                <img class="expertise-explore-header__close-btn" src="/assets/imgs/close.png" alt="Close">
            </router-link>

            <ul class="expertise-explore-header__anchor-list">
                <li class="expertise-explore-header__anchor-item">
                    <button class="expertise-explore-header__anchor-btn" v-on:click="onAnchorClick('approach')">Approach</button>
                </li>

                <li class="expertise-explore-header__anchor-item">
                    <button class="expertise-explore-header__anchor-btn" v-on:click="onAnchorClick('solutions')">Solutions</button>
                </li>

                <li class="expertise-explore-header__anchor-item">
                    <button class="expertise-explore-header__anchor-btn" v-on:click="onAnchorClick('specialties')">Specialties</button>
                </li>
            </ul>

            <video class="expertise-explore-header__video" autoplay muted loop playsinline>
                <source src="/assets/vids/Hunter-Solutions.mp4" type="video/mp4">
            </video>
        </div>
        
        <div id="approach" class="expertise-explore-approach">
            <h2 class="expertise-explore-approach__heading">APPROACH</h2>

            <div class="expertise-explore-approach__headline-container">
                <div class="expertise-explore-approach__img-container">
                    <img class="expertise-explore-approach__img" src="/assets/imgs/H-red.png" alt="H">
                </div>
                <h2 class="expertise-explore-approach__headline">At HUNTER, we believe that consumer attention can never truly be bought or owned, it is always earned.</h2>
            </div>

            <p class="expertise-explore-approach__paragraph">A <router-link to="/expertise/solutions/insights">deep understanding</router-link> of people – what they care about, what influences them, and how and where they seek information, inspiration and expertise – is at the heart of everything we do. We hunt for the intersection between relevant cultural and business conversations (what are people talking about?) and our clients’ communications objectives (what do we want them to know, think or do?).<br><br>From there, we create <router-link to="/expertise/solutions/strategy">strategic</router-link> programming, content and relationships that position companies and brands within the conversations and search results that matter, connecting them with the audiences they need to reach – from consumers and customers to employees, business leaders, partners, media and other key stakeholders.<br><br>To do so, we build integrated teams of specialists across communications disciplines and industry sectors based on each client’s business, audience and program needs. And we do it all en Ingl&eacute;s y Espa&ntilde;ol.</p>
        </div>

        <div id="solutions" class="expertise-explore-solutions">
            <div class="expertise-explore-solutions__nav-container">
                <h2 class="expertise-explore-solutions__heading">Solutions</h2>
                
                <ul class="expertise-explore-solutions__btn-list">
                    <li class="expertise-explore-solutions__btn-item">
                        <router-link class="expertise-explore-solutions__btn creative-services" to="/expertise/solutions/creative-services">Creative Services</router-link>
                    </li>

                    <li class="expertise-explore-solutions__btn-item">
                        <router-link class="expertise-explore-solutions__btn corporate-communications" to="/expertise/solutions/corporate-communications">Corporate Communications</router-link>
                    </li>

                    <li class="expertise-explore-solutions__btn-item">
                        <router-link class="expertise-explore-solutions__btn crisis-issues" to="/expertise/solutions/crisis-issues-management">Crisis & Issues Management</router-link>
                    </li>

                    <li class="expertise-explore-solutions__btn-item">
                        <router-link class="expertise-explore-solutions__btn entertainment" to="/expertise/solutions/entertainment">Entertainment</router-link>
                    </li>

                    <li class="expertise-explore-solutions__btn-item">
                        <router-link class="expertise-explore-solutions__btn experiential" to="/expertise/solutions/experiential">Experiential</router-link>
                    </li>

                    <li class="expertise-explore-solutions__btn-item">
                        <router-link class="expertise-explore-solutions__btn global" to="/expertise/solutions/global">Global</router-link>
                    </li> 

                    <li class="expertise-explore-solutions__btn-item">
                        <router-link class="expertise-explore-solutions__btn influencer" to="/expertise/solutions/influencer">Influencer</router-link>
                    </li>

                    <li class="expertise-explore-solutions__btn-item">
                        <router-link class="expertise-explore-solutions__btn insights" to="/expertise/solutions/insights">Insights</router-link>
                    </li>

                    <li class="expertise-explore-solutions__btn-item">
                        <router-link class="expertise-explore-solutions__btn multicultural" to="/expertise/solutions/multicultural">Multicultural</router-link>
                    </li>

                    <li class="expertise-explore-solutions__btn-item">
                        <router-link class="expertise-explore-solutions__btn partnerships" to="/expertise/solutions/partnerships">Partnerships</router-link>
                    </li>   
                    
                    <li class="expertise-explore-solutions__btn-item">
                        <router-link class="expertise-explore-solutions__btn pr" to="/expertise/solutions/media-relations">Media Relations</router-link>
                    </li>

                    <li class="expertise-explore-solutions__btn-item">
                        <router-link class="expertise-explore-solutions__btn purpose" to="/expertise/solutions/impact">Impact</router-link>
                    </li>

                    <li class="expertise-explore-solutions__btn-item">
                        <router-link class="expertise-explore-solutions__btn social" to="/expertise/solutions/social-digital">Social + Digital</router-link>
                    </li>

                    <li class="expertise-explore-solutions__btn-item">
                        <router-link class="expertise-explore-solutions__btn strategy" to="/expertise/solutions/strategy">Strategy</router-link>
                    </li> 
                </ul>
            </div>

            <div class="expertise-explore-solutions__content-container">    
                <router-link class="expertise-explore-solutions__back-to-solutions" to="/expertise/solutions">&lt; View all solutions</router-link>

                <h2 class="expertise-explore-solutions__content-heading">{{solutionsTitle}}</h2>
                
                <div class="expertise-explore-solutions__paragraph-container" v-for="paragraph in solutionsParagraphArray">
                    <h3 class="expertise-explore-solutions__content-sub-heading" v-html="paragraph.Title"></h3>

                    <p class="expertise-explore-solutions__content-paragraph" v-html="paragraph.Paragraph"></p>
                </div>

                <div class="expertise-explore-solutions__other-solutions">
                    <h2 class="expertise-explore-solutions__other-heading">Other solutions to explore</h2>

                    <ul class="expertise-explore-solutions__other-list">
                        <li v-for="otherSolution in otherSolutionsArray" class="expertise-explore-solutions__other-item">
                            <router-link :to="'/expertise/solutions/' + titleToSlug(otherSolution.MainTitle)" class="expertise-explore-solutions__other-link">{{otherSolution.MainTitle}}</router-link>
                        </li>
                    </ul>
                </div>

                <div class="expertise-explore-related">
                    <h3 class="expertise-explore-solutions__related-heading">Our 
                        <template v-if="solutionsTitle === 'PARTNERSHIPS'">
                            Partnership
                        </template>

                        <template v-else>
                            {{solutionsTitle}}
                        </template>
                        
                        Work
                    </h3>

                    <ul class="expertise-explore-solutions__related-list">
                        <li v-for="related in relatedArray" class="expertise-explore-solutions__related-item">
                            <router-link :to='"/work/case-studies/" + related.Slug' class="expertise-explore-solutions__related-item-link">
                                <div class="expertise-explore-solutions__related-item-content">
                                    <h2 class="expertise-explore-solutions__related-item-heading" v-html=related.Title></h2>
                                    <h3 class="expertise-explore-solutions__related-item-sub-heading" v-html=related.TitleSub></h3>
                                </div>

                                <img class="expertise-explore-solutions__related-item-image"  :src=related.Image.Related :alt=related.Image.Related>
                            </router-link>
                        </li>
                    </ul>

                    <div class="expertise-explore-solutions__related-view-all-work-container">
                        <router-link to="/work/case-studies" class="expertise-explore-solutions__related-view-all-work-link">View All Work</router-link>
                    </div>
                </div>
            </div>
        </div>

        <div id="specialties" class="expertise-explore-specialties">
            <h2 class="expertise-explore-specialties__heading">Specialties</h2>

            <ul class="expertise-explore-specialties__list">
                <li v-for="specialty in specialtiesModel" class="expertise-explore-specialties__item">
                    <!--<router-link :id=specialty.Slug class="expertise-explore-specialties__header-container" :to='"/expertise/specialties/" + specialty.Slug' replace>
                        <h2 class="expertise-explore-specialties__header-heading" v-html=specialty.Title></h2>
                    </router-link>-->

                    <a :id=specialty.Slug class="expertise-explore-specialties__header-container" v-on:click="specialtyClick(specialty.Slug)">
                        <h2 class="expertise-explore-specialties__header-heading" v-html=specialty.Title></h2>
                    </a>

                    <div class="expertise-explore-specialties__body-container">
                        <div class="expertise-explore-specialties__body-wrapper">

                            <ul class="expertise-explore-specialties__image-list">
                                <li class="expertise-explore-specialties__image-item" v-for="image in specialty.Images">
                                    
                                    <div class="expertise-explore-specialties__image-container">
                                        <img class="expertise-explore-specialties__image" :src=image.url alt="">
                                    </div>
                                </li>
                            </ul>


                            <div class="expertise-explore-specialties__body-copy" v-html=specialty.Paragraph></div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
  
        <div class="expertise-explore-footer">
            <h2 class="expertise-explore-footer__heading">Learn more...</h2>
            <div class="expertise-explore-footer__link-container">
                <a href="/work/case-studies" class="expertise-explore-footer__link">Work</a>
                <a href="/contact" class="expertise-explore-footer__link">Contact</a>
            </div>
        </div>
    </div>
</template>

<style scoped lang="less">
    @import "../less/breakpoints.less";

    .expertise-explore {
        background-color: #003a4a;
        color: #ffffff;
        overflow-x: hidden;
        position: relative;
    }

    .expertise-explore-header {
        height: 0;
        overflow: hidden;
        position:relative;
        width: 100%;
    }

    .expertise-explore-header__video {
        background-color: #ffffff;
        position: relative;
        width: 100%;

        @media @breakpoint__tablet--small {
            height: 75vh;
        }

        @media @breakpoint__mobile--large {
            height: 100vh;
        }
    }

    .expertise-explore-header__close-btn-link {
        display: block;
        left: 25px;
        position: absolute;
        top: 20px;
        z-index: 100;

        @media @breakpoint__mobile--large {
            left: 15px;
        }
    }

    .expertise-explore-header__close-btn {
        cursor: pointer;
        display: block;
        width: 49px;
        z-index: 70;

        @media @breakpoint__mobile--large {
            width: 36px;
        }
    }

    .expertise-explore-header__anchor-list {
        margin: 0;
        padding: 0;
        position: absolute;
        text-align: center;
        top: 80px;
        width: 100%;
        z-index: 10;
    }

    .expertise-explore-header__anchor-item {
        display: inline-block;
        padding: 0 15px;

        @media @breakpoint__tablet--small {
            padding: 0 5px;
        }

        &:nth-child(2) {
            border-left: solid 2px #e40046;
            border-right: solid 2px #e40046;
        }
    }

    .expertise-explore-header__anchor-btn {
        background: none;
        border: none;
        color: #003a4a;
        cursor: pointer;
        font-family: Flama, Arial, Helvetica, sans-serif;
        font-size: 18px;
        letter-spacing: 0.3px;
        padding: 0;
        text-decoration: none;
        text-transform: uppercase;

        @media @breakpoint__tablet--small {
            font-size: 14px;
        }
    }

    .expertise-explore-approach {
        box-sizing: border-box;
        margin: 0 auto;
        max-width: 1300px;
        opacity: 0;
        padding: 80px 50px 90px;
        width: 100%;

        @media @breakpoint__mobile--large {
            padding: 50px 20px;
        }
    }

    .expertise-explore-approach__content-container {

        @media @breakpoint__mobile--large {
            padding: 0 20px;
        }
    }

    .expertise-explore-approach__heading {
        color: #fff;
        font-family: Flama-Bold, Arial, Helvetica, sans-serif;
        font-size: 1.8em;
        letter-spacing: 1px;
        margin: 0 0 40px 0;
        opacity: 0;
        transform: translateY(-20px);

        @media @breakpoint__mobile--large {
            font-size: 1.2em;
        }
    }

    .expertise-explore-approach__headline-container {
        display: flex;
        opacity: 0;
        transform: translateY(-20px);

        @media @breakpoint__mobile--large {
            display: block;
            margin-bottom: 40px;
        }
    }

    .expertise-explore-approach__img-container {
        margin-bottom: 30px;
    }

    .expertise-explore-approach__img {
        margin-right: 30px;
        width: 100px;
    }

    .expertise-explore-approach__headline {
        color: #fff;
        font-family: Flama-Bold, Arial, Helvetica, sans-serif;
        font-size: 1.8em;
        letter-spacing: 1px;
        margin: 0 0 20px 0;
        max-width: 800px;

        @media @breakpoint__mobile--large {
            font-size: 1.2em;
        }
    }

    .expertise-explore-approach__paragraph {
        letter-spacing: 1px;
        line-height: 1.8em;
        margin: 0;
        max-width: 1000px;
        opacity: 0;
        transform: translateY(-20px);

        @media @breakpoint__mobile--large {
            font-size: 0.9em;
        }
    }

    .expertise-explore-specialties {
        box-sizing: border-box;
        max-width: 1300px;
        margin: 0 auto;
        opacity: 0;
        padding: 80px 50px 0;
        position: relative;
        width: 100%;
        z-index: 10;

        @media @breakpoint__mobile--large {
            padding: 60px 25px 0;
        }
    }
    
    .expertise-explore-specialties__heading {
        color: #ffffff;
        font-family: Flama-Bold, Arial, Helvetica, sans-serif;
        font-size: 30px;
        margin: 0 0 20px;
        text-transform: uppercase;

        @media @breakpoint__mobile--large {
            font-size: 26px;
        }
    }

    .expertise-explore-specialties__list {
        list-style-type: none;
        margin: 0;
        padding: 0;
    }

    .expertise-explore-specialties__item {
        border-bottom: 0.5px solid #707070;
        margin: 0;
        padding: 30px 0 0;
    }
    
    .expertise-explore-specialties__header-container {
        cursor: pointer;
        display: block;
        margin: 0 0 30px;
        position: relative;
        text-decoration: none;

        &:after {
            color: #ffffff;
            content: "+";
            font-family: Flama-Bold, Arial, Helvetica, sans-serif;
            font-size: 30px;
            line-height: 1;
            position: absolute;
            right: 20px;
            top: 47%;
            transform: translateY(-50%);
        }

        &.active {
            &:after {
                content: "-";
            }
        }
    }

    
    .expertise-explore-specialties__body-copy {
        color: #ffffff;
        font-size: 18px;
        line-height: 2;
        padding-bottom: 40px;

        @media @breakpoint__mobile--large {
            font-size: 16px;
        }
    }
    
    .expertise-explore-specialties__header-heading {
        color: #E40046;
        font-family: Flama-Bold, Arial, Helvetica, sans-serif;
        font-size: 22px;
        margin: 0;
        text-transform: uppercase;
        width: 80%;
    }
    
    .expertise-explore-specialties__header-location {
        color: #ffffff;
        font-size: 22px;
        margin: 0 0 20px;
        width: 80%;
    }
    
    .expertise-explore-specialties__body-container {
        height: 0;
        overflow: hidden;
    }

    .expertise-explore-specialties__body-wrapper {
        margin-bottom: 40px;
    }

    .expertise-explore-specialties__image-list {
        margin: 0 0 15px;
        padding: 0;
    }

    .expertise-explore-specialties__image-item {
        box-sizing: border-box;
        display: inline-block;
        list-style-type: none;
        margin: 0 50px 40px;
        transform: translateY(20px);
        width: calc(~"(100% / 3) - (100px / 3)");
        vertical-align: top;

        .expertise-explore-specialties__image-container {
            padding-top: 79.2%;
            width: 100%;
        }

        .expertise-explore-specialties__image {
            display: block;
            position: absolute;
            top: 0;
            width: 100%;
        }

        &:first-child {
            margin: 0 0 50px;
        }

        &:last-child {
            margin: 0 0 50px;
        }

        @media @breakpoint__tablet--small {
            padding: 0 0 25px;
            margin: 0 !important;
            width: 100%;
        }
    }

    .expertise-explore-specialties__image {
        -webkit-mask-image: -webkit-radial-gradient(white, black);
        border-radius: 40px;
        display: block;
        overflow: hidden;
        margin-bottom: 30px;
        position: relative;
        width: 100%;
    }

    .expertise-explore-solutions {
        background-color: #ffffff;
        border-radius: 120px;
        box-sizing: border-box;
        height: auto;
        opacity: 0;
        padding: 100px 0 100px;
        position: relative;
        transition: 0.3s all;

        @media @breakpoint__tablet--large {
            border-radius: 60px;
            padding: 60px 0 60px;
        }

        @media @breakpoint__mobile--large {
            border-radius: 40px;
            padding: 50px 0 50px;
        }
    }

    .expertise-explore-solutions__nav-container {
        padding: 190px 0 230px;
        position: relative;

        @media @breakpoint__tablet--large {
            padding: 280px 0 280px;
        }

        @media @breakpoint__tablet--small {
            padding: 220px 0 220px;
        }
    }

    .expertise-explore-solutions__heading {
        color: #003a4a;
        font-family: Flama-Bold, Arial, Helvetica, sans-serif;
        font-size: 96px;
        letter-spacing: 1.5px;
        line-height: 1;
        margin: 0;
        padding: 0;
        position: relative;
        text-align: center;
        text-transform: uppercase;
        z-index: 100;

        @media @breakpoint__tablet--large {
            font-size: 72px;
        }

        @media @breakpoint__tablet--small {
            font-size: 60px;
        }

        @media @breakpoint__mobile--large {
            font-size: 40px;
        }
    }

    .expertise-explore-solutions__btn-list {
        position: relative;
        left: 50%;
        list-style-type: none;
        width: 0;
        z-index: 10;
    }

    @keyframes MoveUpDown {
        0%, 100% {
            transform: translateY(0);
        }
        50% {
            transform: translateY(-20%);
        }
    }

    .expertise-explore-solutions__btn {
        background: #ffffff;
        border: 1px solid #e40046;
        border-radius: 5px; 
        color:#003a4a;
        cursor: pointer;
        font-family: Flama, Arial, Helvetica, sans-serif;
        font-size: 15px;
        letter-spacing: 1.4px;
        line-height: 1;
        padding: 4px 12px 4px 12px;
        position: absolute;
        text-decoration: none;
        text-transform: uppercase; 
        transition: 0.3s background, 0.3s color;

        @media @breakpoint__tablet--small {
            font-size: 14px;
            padding: 4px 6px;
        }

        @media @breakpoint__mobile--large {
            font-size: 13px;
            padding: 3px 6px;
        }

        &:hover {
            background: #e40046;
            color: #ffffff;
        }

        &.updown-anim {
            animation: MoveUpDown 2s linear infinite;
        }

        &.creative-services {
            left: -10px;
            top: 50px;

            &:after {
                border-bottom: dashed 1px #d3d3d3;
                content: "";
                height: 1px;
                left: 30%;
                top: -3px;
                transform: rotate(-96deg);
                position: absolute;
                width: 125px;
                z-index: 0;
                transform-origin: bottom left;

                @media @breakpoint__tablet--large {
                    transform: rotate(-104deg);
                    width: 116px;
                }

                @media @breakpoint__tablet--small {
                    transform: rotate(-104deg);
                    width: 91px;
                }

                @media @breakpoint__mobile--large {
                    display: none;
                }
            }

            @media @breakpoint__tablet--large {
                left: -80px;
                top: 90px;
            }

            @media @breakpoint__tablet--small {
                left: -40px;
                top: 65px;
            }

            @media @breakpoint__mobile--large {
                left: -30px;
                top: 70px;
            }
        }
        
        &.corporate-communications {
            left: -280px;
            top: 190px;
            max-width: 160px;
            text-align: center;

            &:after {
                border-bottom: dashed 1px #d3d3d3;
                content: "";
                height: 1px;
                left: 70%;
                top: -3px;
                transform: rotate(-85deg);
                position: absolute;
                width: 225px;
                z-index: 0;
                transform-origin: bottom left;

                @media @breakpoint__tablet--large {
                    transform: rotate(-104deg);
                    width: 116px;
                }

                @media @breakpoint__tablet--small {
                    transform: rotate(-104deg);
                    width: 91px;
                }

                @media @breakpoint__mobile--large {
                    display: none;
                }
            }

            @media @breakpoint__tablet--large {
                left: -80px;
                top: 90px;
            }

            @media @breakpoint__tablet--small {
                left: -40px;
                top: 65px;
            }

            @media @breakpoint__mobile--large {
                left: -30px;
                top: 70px;
            }
        }

        &.crisis-issues {
            left: -110px;
            top: 115px;
            max-width: 160px;
            text-align: center;

            &:after {
                border-bottom: dashed 1px #d3d3d3;
                content: "";
                height: 1px;
                left: 30%;
                top: -3px;
                transform: rotate(-96deg);
                position: absolute;
                width: 155px;
                z-index: 0;
                transform-origin: bottom left;

                @media @breakpoint__tablet--large {
                    transform: rotate(-104deg);
                    width: 116px;
                }

                @media @breakpoint__tablet--small {
                    transform: rotate(-104deg);
                    width: 91px;
                }

                @media @breakpoint__mobile--large {
                    display: none;
                }
            }

            @media @breakpoint__tablet--large {
                left: -80px;
                top: 90px;
            }

            @media @breakpoint__tablet--small {
                left: -40px;
                top: 65px;
            }

            @media @breakpoint__mobile--large {
                left: -30px;
                top: 70px;
            }
        }
        
        &.entertainment {
            left: 140px;
            top: -290px;

            &:after {
                border-bottom: dashed 1px #d3d3d3;
                content: "";
                height: 1px;
                left: 50%;
                bottom: -3px;
                transform: rotate(105deg);
                position: absolute;
                width: 185px;
                z-index: 0;
                transform-origin: bottom left;

                @media @breakpoint__tablet--large {
                    transform: rotate(93deg);
                    width: 272px;
                }

                @media @breakpoint__tablet--small {
                    transform: rotate(112deg);
                    width: 198px;
                }

                @media @breakpoint__mobile--large {
                    display: none;
                }
            }

            @media @breakpoint__tablet--large {
                left: 80px;
                top: -360px;
            }

            @media @breakpoint__tablet--small {
                left: 40px;
                top: -265px;
            }

            @media @breakpoint__mobile--large {
                left: 10px;
                top: -240px;
            }
        }
        
        &.experiential {
            left: -70px;
            top: -320px;

            &:after {
                border-bottom: dashed 1px #d3d3d3;
                content: "";
                height: 1px;
                left: 50%;
                bottom: -3px;
                transform: rotate(88deg);
                position: absolute;
                width: 210px;
                z-index: 0;
                transform-origin: bottom left;

                @media @breakpoint__tablet--large {
                    transform: rotate(95deg);
                    width: 245px;
                }

                @media @breakpoint__tablet--small {
                    transform: rotate(98deg);
                    width: 170px;
                }

                @media @breakpoint__mobile--large {
                    display: none;
                }
            }

            @media @breakpoint__tablet--large {
                left: -150px;
                top: -350px;
            }

            @media @breakpoint__tablet--small {
                left: -125px;
                top: -250px;
            }

            @media @breakpoint__mobile--large {
                left: -135px;
                top: -260px;
            }
        }
        
        &.global {
            left: 200px;
            top: 50px;

            &:after {
                border-bottom: dashed 1px #d3d3d3;
                content: "";
                height: 1px;
                left: 50%;
                top: -3px;
                transform: rotate(-100deg);
                position: absolute;
                width: 85px;
                z-index: 0;
                transform-origin: bottom left;

                @media @breakpoint__tablet--large {
                    transform: rotate(-110deg);
                    width: 78px;
                }

                @media @breakpoint__tablet--small {
                    transform: rotate(-97deg);
                    width: 65px;
                }

                @media @breakpoint__mobile--large {
                    display: none;
                }
            }

            @media @breakpoint__tablet--large {
                left:  170px;
                top: 50px;
            }

            @media @breakpoint__tablet--small {
                left: 135px;
                top: 40px;
            }

            @media @breakpoint__mobile--large {
                left: 65px;
                top: 30px;
            }
        }
        
        &.influencer {
            left: 50px;
            top: -210px;

            &:after {
                border-bottom: dashed 1px #d3d3d3;
                content: "";
                height: 1px;
                left: 50%;
                bottom: -3px;
                transform: rotate(85deg);
                position: absolute;
                width: 100px;
                z-index: 0;
                transform-origin: bottom left;

                @media @breakpoint__tablet--large {
                    transform: rotate(112deg);
                    width: 200px;
                }

                @media @breakpoint__tablet--small {
                    transform: rotate(100deg);
                    width: 115px;
                }

                @media @breakpoint__mobile--large {
                    display: none;
                }
            }

            @media @breakpoint__tablet--large {
                left: 50px;
                top: -275px;
            }

            @media @breakpoint__tablet--small {
                left: 60px;
                top: -195px;
            }

            @media @breakpoint__mobile--large {
                left: 40px;
                top: -120px;
            }
        }
        
        &.insights {
            left: 60px;
            top: 210px;

            &:after {
                border-bottom: dashed 1px #d3d3d3;
                content: "";
                height: 1px;
                left: 40%;
                top: -3px;
                transform: rotate(-86deg);
                position: absolute;
                width: 265px;
                z-index: 0;
                transform-origin: bottom left;

                @media @breakpoint__tablet--large {
                    left: 50%;
                    transform: rotate(-92deg);
                    width: 240px;
                }

                @media @breakpoint__tablet--small {
                    transform: rotate(-96deg);
                    width: 177px;
                }

                @media @breakpoint__mobile--large {
                    display: none;
                }
            }

            @media @breakpoint__tablet--large {
                left: 50px;
                top: 220px;
            }

            @media @breakpoint__tablet--small {
                left: 10px;
                top: 150px;
            }

            @media @breakpoint__mobile--large {
                left: 25px;
                top: 200px;
            }
        }
        
        &.multicultural {
            left: 140px;
            top: 140px;

            &:after {
                border-bottom: dashed 1px #d3d3d3;
                content: "";
                height: 1px;
                left: 40%;
                top: -3px;
                transform: rotate(-106deg);
                position: absolute;
                width: 180px;
                z-index: 0;
                transform-origin: bottom left;

                @media @breakpoint__tablet--large {
                    transform: rotate(-86deg);
                    width: 167px;
                }

                @media @breakpoint__tablet--small {
                    transform: rotate(-108deg);
                    width: 131px;
                }

                @media @breakpoint__mobile--large {
                    display: none;
                }
            }

            @media @breakpoint__tablet--large {
                left: 70px;
                top: 140px;
            }

            @media @breakpoint__tablet--small {
                left: 60px;
                top: 100px;
            }

            @media @breakpoint__mobile--large {
                left: 5px;
                top: 135px;
            }
        }

        &.partnerships {
            left: -160px;
            top: -240px;

            &:after {
                border-bottom: dashed 1px #d3d3d3;
                content: "";
                height: 1px;
                left: 50%;
                bottom: -3px;
                transform: rotate(86deg);
                position: absolute;
                width: 135px;
                z-index: 0;
                transform-origin: bottom left;

                @media @breakpoint__tablet--large {
                    width: 130px;
                }

                @media @breakpoint__tablet--small {
                    transform: rotate(77deg);
                    width: 100px;
                }

                @media @breakpoint__mobile--large {
                    display: none;
                }
            }

            @media @breakpoint__tablet--large {
                left: -80px;
                top: -220px;
            }

            @media @breakpoint__tablet--small {
                left: -110px;
                top: -180px;
            }

            @media @breakpoint__mobile--large {
                left: -140px;
                top: -120px;
            }
        }

        &.pr {
            left: -280px;
            top: -300px;

            &:after {
                border-bottom: dashed 1px #d3d3d3;
                content: "";
                height: 1px;
                left: 50%;
                bottom: -3px;
                transform: rotate(80deg);
                position: absolute;
                width: 190px;
                z-index: 0;
                transform-origin: bottom left;

                @media @breakpoint__tablet--large {
                    transform: rotate(57deg);
                    width: 210px;
                }

                @media @breakpoint__tablet--small {
                    transform: rotate(62deg);
                    width: 149px;
                }

                @media @breakpoint__mobile--large {
                    display: none;
                }
            }

            @media @breakpoint__tablet--large {
                left: -275px;
                top: -265px;
            }

            @media @breakpoint__tablet--small {
                left: -200px;
                top: -215px;
            }

            @media @breakpoint__mobile--large {
                left: -130px;
                top: -195px;
            }
        }
        
        &.purpose {
            left: -320px;
            top: -175px;

            &:after {
                border-bottom: dashed 1px #d3d3d3;
                content: "";
                height: 1px;
                left: 50%;
                bottom: -3px;
                transform: rotate(75deg);
                position: absolute;
                width: 65px;
                z-index: 0;
                transform-origin: bottom left;

                @media @breakpoint__tablet--large {
                    transform: rotate(65deg);
                    width: 105px;
                }

                @media @breakpoint__tablet--small {
                    transform: rotate(72deg);
                    width: 58px;
                }

                @media @breakpoint__mobile--large {
                    display: none;
                }
            }

            @media @breakpoint__tablet--large {
                left: -290px;
                top: -165px;
            }

            @media @breakpoint__tablet--small {
                left: -220px;
                top: -140px;
            }

            @media @breakpoint__mobile--large {
                left: -65px;
                top: -175px;
            }
        }

        &.social {
            left: -335px;
            top: 50px;
            max-width:300px;
            text-align: center;

            &:after {
                border-bottom: dashed 1px #d3d3d3;
                content: "";
                height: 1px;
                left: 50%;
                top: -3px;
                transform: rotate(-77deg);
                position: absolute;
                width: 90px;
                z-index: 0;
                transform-origin: bottom left;

                @media @breakpoint__tablet--large {
                    transform: rotate(-65deg);
                    width: 92px;
                }

                @media @breakpoint__tablet--small {
                    transform: rotate(-68deg);
                    width: 80px;
                }

                @media @breakpoint__mobile--large {
                    display: none;
                }
            }

            @media @breakpoint__tablet--large {
                left: -280px;
                top: 60px;
            }

            @media @breakpoint__tablet--small {
                left: -215px;
                top: 50px;
            }

            @media @breakpoint__mobile--large {
                left: -135px;
                top: 25px;
            }
        }
        
        &.strategy {
            left: 220px;
            top: -170px;

            &:after {
                border-bottom: dashed 1px #d3d3d3;
                content: "";
                height: 1px;
                left: 50%;
                bottom: -3px;
                transform: rotate(115deg);
                position: absolute;
                width: 65px;
                z-index: 0;
                transform-origin: bottom left;

                @media @breakpoint__tablet--large {
                    transform: rotate(117deg);
                    width: 93px;
                }

                @media @breakpoint__tablet--small {
                    transform: rotate(100deg);
                    width: 57px;
                }

                @media @breakpoint__mobile--large {
                    display: none;
                }
            }

            @media @breakpoint__tablet--large {
                left: 180px;
                top: -175px;
            }

            @media @breakpoint__tablet--small {
                left: 115px;
                top: -140px;
            }

            @media @breakpoint__mobile--large {
                left: 52px;
                top: -180px;
            }
        }
    }

    .expertise-explore-solutions__content-container {
        box-sizing: border-box;
        display: none;
        margin: 0 auto;
        max-width: 1300px;
        padding: 0 50px;

        @media @breakpoint__mobile--large {
            padding: 0 25px;
        }
    }

    .expertise-explore-solutions__back-to-solutions {
        background: none;
        border: none;
        color: #e40046;
        cursor: pointer;
        display: inline-block;
        font-size: 16px;
        font-weight: 700;
        margin: 0 0 45px;
        text-decoration: none;

        &:focus {
            outline: none;
        }
    }

    .expertise-explore-solutions__paragraph-container {
        margin-bottom: 50px;
    }

    .expertise-explore-solutions__content-heading {
        background: #e40046;
        border-radius: 5px;
        color: #fff;
        display: table;
        font-size: 30px;
        margin: 0 0 50px;
        padding: 1px 14px 5px 14px;
        text-transform: uppercase;
    }

    .expertise-explore-solutions__content-sub-heading {
        color: #003a4a;
        font-size: 22px;
        font-weight: normal;
        margin: 0 0 20px 0;
        letter-spacing: 1px;
        text-transform: uppercase;
    }

    .expertise-explore-solutions__content-paragraph {
        color: #003a4a;
        letter-spacing: 1px;
        line-height: 1.8em;
        margin: 0;
        max-width: 775px;
    }

    .expertise-explore-solutions__other-solutions {
        margin-bottom: 60px;
    }

    .expertise-explore-solutions__other-heading {
        color: #003a4a;
        font-family: Flama-Bold, Arial, Helvetica, sans-serif;
        font-size: 22px;
    }

    .expertise-explore-solutions__other-list {
        margin: 0;
        padding: 0;
    }

    .expertise-explore-solutions__other-item {
        display: inline-block;
        margin: 10px 15px 10px 0;
    }

    .expertise-explore-solutions__other-link {
        border: 1px solid #e40046;
        border-radius: 5px;
        background: #fff;
        color: #003a4a;
        cursor: pointer;
        display: block;
        font-size: 1.1em;
        letter-spacing: 1.2px;
        line-height: 23px;
        padding: 2px 5px 2px;
        text-decoration: none;
        text-transform: uppercase;

        &:hover {
            background: #e40046;
            color: #ffffff;
        }
    }

    .expertise-explore-related {
        box-sizing: border-box;
        margin: 0;
        width: 100%;

        @media @breakpoint__mobile--large {
            padding: 0;
        }
    }

    .expertise-explore-solutions__related-heading {
        color: #003a4a;
        font-family: Flama-Bold, Arial, Helvetica, sans-serif;
        font-size: 24px;
        letter-spacing: 1.2px;
        margin: 0 0 30px 0;
        text-align: center;
        text-transform: uppercase;

        @media @breakpoint__mobile--large {
            text-align: left;
        }
    }

    .expertise-explore-solutions__related-list {
        box-sizing: border-box;
        margin: 0 0 30px;
        padding: 0;
        text-align: center;
        width: 100%;

        @media @breakpoint__mobile--large {
            margin: 0 0 50px;
        }
    }

    .expertise-explore-solutions__related-item {
        box-sizing: border-box;
        display: inline-block;
        list-style-type: none;
        margin: 0 0 50px 50px;
        transform: translateY(20px);
        width: calc(~"(100% / 3) - (50px / 3 * 2)");
        vertical-align: top;

        &:first-child {
            margin: 0 0 30px 0;

            @media @breakpoint__mobile--large {
                margin: 0 0 20px;
            }
        }

        @media @breakpoint__tablet--medium {
            margin: 0 0 30px 15px;
            width: calc(~"(100% / 3) - (15px / 3 * 2)");
        }

        @media @breakpoint__tablet--small {
            margin:0 0 50px;
            padding: 0;
            width: 100%;
        }

        @media @breakpoint__mobile--large {
            margin: 0 0 20px;
            padding: 0;
            width: 100%;
        }

        .news-explore-articles__image {
            display: block;
            width: 100%;
        }
    }

    .expertise-explore-solutions__related-item-link {
        -webkit-mask-image: -webkit-radial-gradient(white, black);
        border-radius: 62px;
        display: block;
        overflow: hidden;
        position: relative;

        &:before {
            content: "";
            background-color: #003A4A;
            height: 100%;
            left: 0;
            opacity: 0;
            position: absolute;
            transition: 0.3s opacity;
            top: 0;
            width: 100%;
        }

        @media @breakpoint__tablet--large {
            border-radius: 30px;

            &:before {
                opacity: 0.78;
            }
        }
        
        @media @breakpoint__mobile--large {
            border-radius: 40px;
        }

        &:hover {
            &:before {
                opacity: 0.78;
            }

            .expertise-explore-solutions__related-item-heading {
                opacity: 1;
                transform: translateY(0);
                transition-delay: 0.1s;
            }

            .expertise-explore-solutions__related-item-sub-heading {
                opacity: 1;
                transform: translateY(0);
                transition-delay: 0.2s;
            }
        }
    }

    .expertise-explore-solutions__related-item-content {
        left: 50%;
        position: absolute;
        text-align: center;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 80%;
        z-index: 10;
    }

    .expertise-explore-solutions__related-item-heading {
        color: #fff;
        font-family: Flama-Bold, Arial, Helvetica, sans-serif;
        font-size: 22px;
        letter-spacing: 1px;
        margin: 0 0 10px 0;
        text-transform: uppercase;

        @media @breakpoint__tablet--large {
            font-size: 14px;
        }

        @media @breakpoint__tablet--medium {
            font-size: 14px;
        }

        @media @breakpoint__tablet--small {
            font-size: 20px;
        }
    }

    .expertise-explore-solutions__related-item-sub-heading {
        color: #e40046;
        font-size: 22px;
        font-weight: normal;
        letter-spacing: 1px;
        margin: 0;

        @media @breakpoint__tablet--large{
            font-size: 14px;
        }

        @media @breakpoint__tablet--medium {
            font-size: 14px;
        }

        @media @breakpoint__tablet--small {
            font-size: 20px;
        }
    }

    .expertise-explore-solutions__related-item-heading,
    .expertise-explore-solutions__related-item-sub-heading {
        opacity: 0;
        transform: translateY(40px);
        transition: 0.3s opacity, 0.3s transform;
        transition-delay: 0;

        @media @breakpoint__tablet--large {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .expertise-explore-solutions__related-item-image {
        display: block;
        width: 100%;
    }

    .expertise-explore-solutions__related-view-all-work-container {
        text-align: center;
    }

    .expertise-explore-solutions__related-view-all-work-link {
        background: #e40046;
        border-radius: 5px;
        color: #fff;
        cursor: pointer;
        display: inline-block;
        font-size: 1em;
        letter-spacing: 1.5px;
        margin: 0 auto;
        min-width: 110px;
        padding: 10px;
        text-align: center;
        text-decoration: none;
        z-index: 20;
    }

    .expertise-explore-footer {
        background: #003a4a;
        opacity: 0;
        padding: 60px 10%;
    }

    .expertise-explore-footer__heading {
        color: #ffffff;
        font-family: Flama-Bold, Arial, Helvetica, sans-serif;
        font-size: 1.8em;
        letter-spacing: 1px;
        margin: 0 0 20px 0;
        text-align: center;
    }

    .expertise-explore-footer__link-container {
        display: block;
        text-align: center;
    }

    .expertise-explore-footer__link {
        background-color: #e40046;
        border: none;
        border-radius: 5px;
        color: #fff;
        cursor: pointer;
        display: inline-block;
        font-size: 16px;
        letter-spacing: 1px;
        padding: 10px 30px;
        text-decoration: none;
        z-index: 20;

        &:first-child {
            margin-right: 30px;

            @media @breakpoint__mobile--small {
                display: table;
                margin: 0 auto 20px;
            }
        }
    }
</style>

<style lang="less">
    .expertise-explore-specialties__body-copy {
        strong {
            color: #E40046;
            font-family: Flama-Bold, Arial, Helvetica, sans-serif;
        }
    }
</style>


<script src="https://player.vimeo.com/api/player.js"></script>

<script>
import { setTimeout } from 'timers';
    export default {
        name: "ExpertiseExplore",
        data()
        {
            return {
                otherSolutionsArray : [],
                relatedArray : [],
                specialtiesModel : [],
                solutionsModel : {},
                solutionsTitle: "",
                solutionsParagraphArray: []
            }
        },
        created : function()
        {
            var vm = this;
            vm.$parent.backgroundColor = "dark";
            vm.$parent.logoColor = "dark";
            var testIfDataLoaded = setInterval(function()
            {
                if (!vm.isObjectEmpty(vm.$parent.modelSolutions))
                {
                    clearInterval(testIfDataLoaded);
                    vm.initSolutionsContent(vm.$parent.modelSolutions);
                    vm.initSpecialtiesContent(vm.$parent.modelSpecialties);
                    vm.initAnimIn();
                    vm.initSubTitle();

                    if (vm.$route.params.id === "approach")
                    {
                        vm.onRouteChange(vm.$route.params.id);
                    }
                }
            }, 500);
        },
        mounted: function()
        {
            TweenMax.to(".header__logo-sub-title-container", 0.2, {width: 0});
        },
        methods: {
            // Helper function to convert title to URL slug
            titleToSlug : function(title)
            {
                return title.toLowerCase().replace(/\s+/g, '-');
            },
            initSolutionsContent : function(data)
            {
                this.solutionsModel = data;
                var vm = this;

                setTimeout(function()
                {
                    if (vm.$route.params.id === "solutions")
                    {
                        vm.onRouteChange(vm.$route.params.id);

                        if (vm.$route.params.child)
                        {
                            vm.solutionsClick(vm.$route.params.child);
                        }
                        else
                        {
                            vm.viewAllSolutionsClick();
                        }
                    }
                }, 2000);
            },
            initSpecialtiesContent : function(data)
            {
                this.specialtiesModel = data;
                var vm = this;
                if (vm.$route.params.id === "specialties")
                {
                    setTimeout(function()
                    {
                        vm.onRouteChange(vm.$route.params.id);

                        if (vm.$route.params.child)
                        {
                            vm.onSpecialtyClick(vm.$route.params.child);
                        }
                    }, 2000);
                }
            },
            initAnimIn : function()
            {
                TweenMax.set(".expertise-explore-header", {height:"auto"});
                TweenMax.from(".expertise-explore-header", 0.6, {height:0, ease: Power2.easeOut});

                var tl = new TimelineMax();
                tl.from(".expertise-explore-header__anchor-list", 0.6, {opacity: 0, delay: 0.6});
                tl.to(".expertise-explore-approach", 0.5, {opacity: 1}, "-=2");
                tl.to(".expertise-explore-approach__heading", 0.5, {transform: "translateY(0)", opacity: 1}, "-=0.7");
                tl.to(".expertise-explore-approach__headline-container", 0.5, {transform: "translateY(0)", opacity: 1}, "-=0.4");
                tl.to(".expertise-explore-approach__paragraph", 0.5, {transform: "translateY(0)", opacity: 1}, "-=0.4");
                tl.to(".expertise-explore-solutions", 0.5, {opacity: 1}, "-=0.3");
                tl.staggerTo(".expertise-explore-solutions__btn", 0, {className:"+=updown-anim"}, 0.15);
                tl.to(".expertise-explore-specialties", 0.5, {opacity: 1}, "-=2");
                tl.to(".expertise-explore-footer", 0.5, {opacity: 1}, "-=1.2");
            },
            initSubTitle : function()
            {
                document.querySelector(".header__logo-sub-title").innerHTML = "Expertise";
                TweenMax.set(document.querySelector(".header__logo-sub-title-container"), {width: "auto"});
                TweenMax.from(document.querySelector(".header__logo-sub-title-container"), 0.3, {width: 0, delay: 0.2});
            },
            onAnchorClick : function(value)
            {
                if (value === this.$router.history.current.params.id)
                {
                    this.onRouteChange(value);
                }
                else
                {
                    this.$router.push("/expertise/" + value);
                }
            },
            onRouteChange : function(id)
            {
                TweenMax.to(window, 1.6, {scrollTo:{y: '#' + id}, autoKill: false, ease: Power4.easeInOut});
            },
            solutionsClick : function(name)
            {
                TweenMax.set(".expertise-explore-solutions__content-container", {opacity: 0});
                this.relatedArray = [];
                // Find solution where the slug matches the URL parameter
                var vm = this;
                var solutionData = null;
                for (var i = 0; i < this.solutionsModel.length; i++) {
                    if (vm.titleToSlug(this.solutionsModel[i].MainTitle) === name.toLowerCase()) {
                        solutionData = this.solutionsModel[i];
                        break;
                    }
                }
                // Get other solutions excluding the current one
                this.otherSolutionsArray = this.solutionsModel.filter(function(solution) {
                    return vm.titleToSlug(solution.MainTitle) !== name.toLowerCase();
                });
                // Special case for Crisis & Issues Management title
                if (name.toLowerCase() === 'crisis-issues-management') {
                    this.solutionsTitle = 'CRISIS & ISSUES MANAGEMENT';
                } else {
                    this.solutionsTitle = solutionData.MainTitle;
                }
                this.solutionsParagraphArray = solutionData.Paragraphs;

                for (var i = 0; i < solutionData.Related.length; i++)
                {
                    this.relatedArray.push(this.findObjectByKey(this.$parent.modelWorkGallery, "Slug", solutionData.Related[i].Slug));
                }
                
                TweenMax.to(window, 1, {scrollTo:{y: "#solutions"}, autoKill: false, ease: Power2.easeInOut});
                TweenMax.to(".expertise-explore-solutions__nav-container", 0.2, {opacity: 0, onComplete: this.showSolution});
            },
            showSolution : function()
            {
                TweenMax.set(".expertise-explore-solutions__nav-container", {display: "none"});
                TweenMax.set(".expertise-explore-solutions__content-container", {display: "block", opacity: 1});
                var tl = new TimelineMax();
                tl.from(".expertise-explore-solutions__content-heading", 0.4, {opacity: 0, transform: "translateY(-20px)", delay: 0.2});
                tl.staggerFrom(".expertise-explore-solutions__paragraph-container", 0.4, {opacity: 0, transform: "translateY(-20px)"}, 0.15, "-=0.5");
                tl.from(".expertise-explore-solutions__other-solutions", 0.4, {opacity: 0, transform: "translateY(-20px)"}, "-=0.2");
                tl.from(".expertise-explore-solutions__related-heading", 0.4, {opacity: 0, transform: "translateY(-20px)"}, "-=0.2");
                tl.staggerFrom(".expertise-explore-solutions__related-item", 0.4, {opacity: 0, transform: "translateY(-20px)"}, 0.15, "-=0.2");
                tl.from(".expertise-explore-solutions__related-view-all-work-container", 0.4, {opacity: 0, transform: "translateY(-20px)"}, "-=0.2");
                tl.from(".expertise-explore-solutions__related-back-to-solutions", 0.4, {opacity: 0, transform: "translateX(20px)"}, "-=0.2");
            },
            viewAllSolutionsClick : function()
            {
                TweenMax.to(".expertise-explore-solutions__content-container", 0.2, {opacity: 0, onComplete: this.viewAllSoltuions});
            },
            viewAllSoltuions: function()
            {
                TweenMax.set(".expertise-explore-solutions__content-container", {display: "none"});
                TweenMax.set(".expertise-explore-solutions__nav-container", {display: "block"});
                TweenMax.to(".expertise-explore-solutions__nav-container", 1, {autoAlpha: 1});
            },
            specialtyClick : function(id)
            {
                if (this.$route.params.child === id)
                {
                    this.$router.push('/expertise/specialties');
                }
                else
                {
                    this.$router.push('/expertise/specialties/' + id);
                }
            },
            onSpecialtyClick : function(id)
            {
                var el = document.querySelector("#" + id);
                if (el.classList.contains("active"))
                {
                    TweenMax.set(el, {className: '-=active'});
                    TweenMax.to(el.nextSibling, 0.8, {height: 0});
                }
                else
                {
                    TweenMax.set(".expertise-explore-specialties__header-container", {className: '-=active'});
                    var wrapperHeight = el.nextSibling.querySelector(".expertise-explore-specialties__body-wrapper").offsetHeight  + "px";
                    TweenMax.set(el, {className: '+=active'});
                    TweenMax.to(".expertise-explore-specialties__body-container", 0.4, {height: 0});
                    TweenMax.to(el.nextSibling, 0.8, {height: wrapperHeight});
                }

                TweenMax.to(window, 0.8, {scrollTo:{y: el.parentNode}, autoKill: false, ease: Power2.easeInOut, delay: 0.4});
            },
            closeAllSpecialties : function() {
                TweenMax.set(".expertise-explore-specialties__header-container", {className: '-=active'});
                TweenMax.to(".expertise-explore-specialties__body-container", 0.4, {height: 0});
            }
        },
        watch:
        {
            '$route' (to, from)
            {
                this.onRouteChange(this.$route.params.id);

                if (this.$route.params.id === "solutions")
                {
                    if (this.$route.params.child)
                    {
                        this.solutionsClick(this.$route.params.child);
                        this.closeAllSpecialties();
                    }
                    else
                    {
                        this.viewAllSolutionsClick();
                        this.closeAllSpecialties();
                    }
                }

                if (this.$route.params.id === "specialties")
                {
                    if (this.$route.params.child)
                    {
                        this.onSpecialtyClick(this.$route.params.child);
                        this.viewAllSolutionsClick();
                    }
                    else
                    {
                        this.closeAllSpecialties();
                        this.viewAllSolutionsClick();
                    }
                }
            }
        }
    };
</script>
